import { render, staticRenderFns } from "./PackLeadWidgetTable.vue?vue&type=template&id=271a91ea"
import script from "./PackLeadWidgetTable.vue?vue&type=script&lang=js"
export * from "./PackLeadWidgetTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports